import { AdminListHandleCancelFunction } from './adminListHandleCancel.type';

const adminListHandleCancel: AdminListHandleCancelFunction = ({ handleOnClose, closeModal }) => {
  handleOnClose();
  closeModal();
};

export default adminListHandleCancel;
